import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../../Component/Loader/loader/loader.component';
import { ApprovalMatrixService } from '../../../../Model/ApprovalMatrix/approval-matrix.service';
import { SessionService } from '../../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../../Util/Toast/toast.service';
import { CustomDateParserFormatter } from '../../../../Util/DateFormat/date-format.service';
import { CommonService } from '../../../../Model/Common/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TooltipService } from '../../../../Util/Tooltip/tooltip.service';
import { UserRightService } from '../../../../Model/UserRight/user-right.service';
import { ConfirmationComponent } from '../../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../../Component/Alert/alert-warning/alert-warning.component';
import { ReimbursementformService } from '../../../../Model/Reimbursement/reimbursementform.service';
import { EmpDetailsService } from '../../../../Model/EmpProfileDetails/emp-details.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-profile-request-detail',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, LoaderComponent, DataTablesModule],
  templateUrl: './profile-request-detail.component.html',
  styleUrl: './profile-request-detail.component.scss'
})
export class ProfileRequestDetailComponent {
  isDisabled: boolean = false;
  isSuper: boolean = false;//for super admin
  GetID = 0;//1-detail,2-request
  isApprovalLavel = true;

  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null,
    EmpMasterId: null,
    EmpCode: null,
    Photo: null as any,
    EmployeeName: null as any,
    BranchName: null,
    ClientLocation: null,
    DesignationMasterId: null,
    DesignationName: null,
    ShiftMasterID: null,
    ShiftTitle: null,

    Remark: null,
    RequestDate: null as any,
    MonthYear: null,

    EmpType: null as any,
    ApprovalStatus: null as any,

  };
  Trackings = [];
  TrackingsUser = [];
  user = [] as any;

  Filter = {
    ModuleMasterId: 7,
    WebESSApprovalRequestTrackingId: 0,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    TransactionId: 0,
    EmpType: null,
    Remark: null,
  }

  EmpOldDocDetail: any[] = []
  EmpNewDocDetail: any[] = []
  OperationType: any = null
  EmpMasterId: any = null
  ESS_EmpProfileUpdateRequestID: any = null

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  dtTrigger: Subject<any> = new Subject<any>();
  
  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    protected dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    protected tooltip: TooltipService,
    private userright: UserRightService,
    private EmpDetail: EmpDetailsService,
  ) {
    this.common.getPageRights();
    // this.common.PageRight.IsView = true;
    // this.common.PageRight.IsAdd = true;
    // this.common.PageRight.IsPrint = true;
    // this.common.PageRight.IsEdit = true;
    // this.common.PageRight.IsDelete = true;
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    this.route.params.subscribe(params => this.OperationType = params['type']);
    this.route.params.subscribe(params => this.EmpMasterId = parseInt(params['eid']));
    this.route.params.subscribe(params => this.ESS_EmpProfileUpdateRequestID = parseInt(params['tid']));

    if (window.location.pathname.includes('todo')) {
      this.GetID = 1;
    } else if (window.location.pathname.includes('request')) {
      this.GetID = 2
    }
  }

  ngOnInit(): void {
    //this.DetailData.EmpType = this.user.EmpType,
    // console.log(this.DetailData.EmpType)
    if (this.user.UserType == 'E') {
      this.Filter.EmpMappingId = this.user.UserId;
    }
    if (this.GetID == 1) {
      this.ApprovalMatrixRequestGet();
      this.ESS_GetUserRole();
    } else if (this.GetID == 2) {
      //this.ESS_ReimbursementLoad();
    }
    this.EmpProfile_InfoDocDetails()
    this.Filter.EmpMasterId = this.user.UserId;
  }

  // ngAfterViewInit(): void {
  //   this.dtTrigger.next(null);
  // }

  // ngOnDestroy(): void {
  //   // Do not forget to unsubscribe the event
  //   this.dtTrigger.unsubscribe();
  // }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 7) {
          if (response.Table.length > 0) {
            this.DetailData = response.Table[0];
          } else if (response.Table1.length > 0) {
            this.DetailData = response.Table1[0];
          } else if (response.Table2.length > 0) {
            this.DetailData = response.Table2[0];
          } else if (response.Table3.length > 0) {
            this.DetailData = response.Table3[0];
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {

        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'pending') {
          if (this.user.UserType == 'A') {
            this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestProcess(SelectType: string) {
    if (((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') || this.isSuper) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to ' + SelectType + '?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.isDisabled = true;
          //this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
          this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
            next: (response) => {
              if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.Cancel();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      }).catch(() => { });
    } else {
      this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
    }
  }

  // Link(Text: string) {
  //   return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'Reimbursement' + '/' + Text;
  // }

  Cancel() {
    if (this.GetID == 1) {
      if (this.user.UserType == 'A') {
        this.router.navigate(['/todo/EmpDetails/']);
      }
      else if (this.user.UserType == 'E') {
        this.router.navigate(['/request/EmpDetails/approval/']);
      }
    }
    else if (this.GetID == 2) {
      this.router.navigate(['/request/EmpDetails/']);
    }
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }

  EmpProfile_InfoDocDetails() {
    this.isDisabled = true
    this.EmpDetail.EmpProfile_InfoDocDetails({ OperationType: this.OperationType, EmpMasterId: this.EmpMasterId, ESS_EmpProfileUpdateRequestID: this.ESS_EmpProfileUpdateRequestID }).subscribe({
      next: (data) => {
        this.EmpOldDocDetail = data.Table;
        this.EmpNewDocDetail = data.Table1;
      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
        this.isDisabled = false
        console.error('Error:', error);
      },
    });
  }
}
